import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
    selector: 'app-terms-of-use',
    templateUrl: './terms-of-use.component.html',
    styleUrls: ['./terms-of-use.component.scss'],
    standalone: false
})
export class TermsOfUseComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<TermsOfUseComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {

  }

  save() {
    this.dialogRef.close('true');
  }

  saveasDraft() {
    this.dialogRef.close('save');
  }


  close() {
    this.dialogRef.close('cancel');
  }

}
